/* eslint-disable react/jsx-pascal-case */

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './Components/Header/NavBar';
import Footer_Ui from './Components/Footer/Footer_Ui';
import NotFound from './Components/Resources/NotFound';
import Home from './Components/Resources/Home';
import About from './Components/Resources/About';
import Work from './Components/Resources/Work';
import Blog from './Components/Resources/Blog';
import Pricing from './Components/Resources/Pricing';
import UIDesign from './Components/Services/UIDesign';
import WebDesign from './Components/Services/WebDesign';
import DigitalMarketing from './Components/Services/DigitalMarketing';
import MobileApp from './Components/Services/MobileApp';
import SaaSDesign from './Components/Services/SaaSDesign';
import VideoEditing from './Components/Services/VideoEditing';
import WebDevelopment from './Components/Services/WebDevelopment';
import Webflow from './Components/Services/Webflow';
import Branding from './Components/Services/Branding';
import Contact from './Components/Resources/Contact';
import Thank from './Components/Resources/Thank';

function App() {
  return (
    <Router>
    <NavBar /> 
    <Routes>
  
    <Route path="*" element={<NotFound />} />
  
    <Route path="/" element={<Home/>} />
    <Route path="/about-us" element={<About/>} />
    <Route path='/work' element={<Work/>}/>
    <Route path="/blog" element={<Blog/>}/>
    <Route path="/pricing" element={<Pricing/>}/>
    <Route path="/contact-us" element={<Contact/>}/>
    <Route path='/thanks-you' element={<Thank/>}/>
 
    <Route path='/uidesign' element={<UIDesign/>}/>
    <Route path='/webdesign' element={<WebDesign/>}/>
    <Route path='/digital-marketing' element={<DigitalMarketing/>}/>
    <Route path='/mobileapp' element={<MobileApp/>}/>
    <Route path='/saasdesign' element={<SaaSDesign/>}/>
    <Route path='/video-editiong' element={<VideoEditing/>}/>
    <Route path='/web-development' element={<WebDevelopment/>}/>
    <Route path='/webflow' element={<Webflow/>}/>
    <Route path='/branding' element={<Branding/>}/>
    </Routes>
    <Footer_Ui/>
  </Router>
  );
}

export default App;
